import React, { useState, useMemo, useEffect, useRef } from 'react'

interface MultiSelectFilterProps {
  title: string
  options: string[]
  selectedValues: string[]
  onSelectionChange: (value: string, isChecked: boolean) => void
}

export const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
  title,
  options,
  selectedValues,
  onSelectionChange
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const filterRef = useRef<HTMLDivElement>(null)

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (filterRef.current && !filterRef.current.contains(event.target as Node) && isOpen) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [isOpen])

  const getAccordionHeading = () => {
    if (isOpen || selectedValues.length === 0) {
      return title
    }

    // Show selected items joined by commas
    return selectedValues.join(', ')
  }

  const sortedOptions = useMemo(() => {
    return [...options].sort((a, b) => a.localeCompare(b))
  }, [options])

  return (
    <div className="app-dropdown-container filters-program-item" ref={filterRef}>
      <button className="app-dropdown-toggle" aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <span className="app-dropdown-toggle-text">{getAccordionHeading()}</span>
        <svg className="svg-icon" aria-hidden="true" focusable="false">
          <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#icon-chevron-down" />
        </svg>
      </button>

      {isOpen && (
        <div className="app-dropdown-panel">
          {sortedOptions.map((option) => (
            <label className="filters-checkbox-item" key={option}>
              {option}
              <input
                type="checkbox"
                value={option}
                checked={selectedValues.includes(option)}
                onChange={(e) => onSelectionChange(option, e.target.checked)}
              />
            </label>
          ))}
        </div>
      )}
    </div>
  )
}